import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Route, withRouter, Redirect, Switch } from "react-router-dom";
import { connect } from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import ListItemText from "@material-ui/core/ListItemText";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { withLastLocation } from "react-router-last-location";
import { withStyles, withTheme } from "@material-ui/core/styles";
import ListSubheader from "@material-ui/core/ListSubheader";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Trans, withTranslation } from "react-i18next";
// import PortalDrawer from "./components/menu/PortalDrawer";
import classNames from "classnames";
import SearchPage from "./components/search/SearchPage";
import { setLayoutType } from "./redux/actions/layoutActions";
import { changeLanguage } from "./redux/actions/universalActions";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import axios, { taxServiceClient } from "./AxiosClient";
import PropertyNames from "./PropertyNames";
import Dictaphone from "./components/voice-to-text/Dictaphone";
import ApiExample from "./apidocs/ApiExample";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import CodeIcon from "@material-ui/icons/Code";
import defaultLogo from "./images/default-logo.svg";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Icon from "@mdi/react";
import { mdiApi, mdiMagnify, mdiAccountQuestion } from "@mdi/js";

const drawerWidth = 250;
const styles = (theme) => ({
  root: {
    width: "100%",
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
    marginRight: "5px",
  },
  searchIcon: {
    width: theme.spacing(9),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  exitButton: {
    marginLeft: "auto",
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200,
      },
    },
  },
  layoutButton: {
    marginRight: -10,
  },
  layoutMenu: {
    marginTop: 20,
  },
  tabsContainer: {
    display: "flex",
    marginLeft: 12,
    marginRight: 24,
    minHeight: 48,
  },
  "fade-enter": {
    opacity: 0,
    zIndex: 1,
  },
  "fade-enter-active": {
    opacity: 1,
    transition: "opacity 250ms ease-in",
  },
  appBar: {
    marginBottom: 10,
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    minHeight: "115px",
  },
  searchStringText: {
    color: theme.palette.common.white,
    // marginTop: 5,
    // marginLeft: 15,
    padding: 12,
  },
  modalAppBar: {
    position: "relative",
  },
  modalToolbar: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  docViewer: {
    display: "flex",
  },
  dialogContainer: {
    display: "flex",
    flexDirection: "column",
    // overflowY: "hidden",
    // overflowX: "hidden",
  },
  green: {
    color: theme.palette.success.main,
  },
  red: {
    color: theme.palette.error.main,
  },
  listIcon: {
    minWidth: 30,
  },
  popper: {
    zIndex: 9999999,
    boxShadow:
      "0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)",
    marginTop: 7,
    maxWidth: "50%",
    maxHeight: "75%",
    overflowX: "hidden",
    overflowY: "auto",
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: `transparent transparent ${
          theme.palette.background.paper
        } transparent`,
      },
    },
  },
  arrow: {
    position: "absolute",
    fontSize: 7,
    width: "3em",
    height: "3em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  paper: {
    // maxWidth: "50%",
  },
  emptyText: {
    textAlign: "center",
    marginBottom: 15,
  },
  tooltip: {
    zIndex: 9999999999999999999,
  },
  infoButton: {
    color: theme.palette.common.white,
  },
  exampleListItem: {
    marginLeft: 30,
  },
  teamSelect: {
    "&:before": {
      borderColor: "white",
    },
    "&:after": {
      borderColor: "white",
    },
  },
  icon: {
    color: "white",
  },
  select: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  drawerPaper: {
    width: drawerWidth,
    flexShrink: 0,
    borderRight: "none",
  },
  drawerHeader: {
    minHeight: "115px",
    backgroundColor: theme.palette.primary.main,
    backgroundSize: "50%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    position: "relative",
  },
  main: {
    marginLeft: drawerWidth + 10,
    marginRight: 10,
  },
});
let messageRef = React.createRef();
export class ApiHome extends Component {
  constructor(props) {
    super(props);
    this.layoutMenuRef = React.createRef();
    this.state = {
      entryAnimation: "",
      exitAnimation: "",
      main: true,
      userTabs: true,
      route: {},
      tailData: {},
      documentData: {},
      layoutData: {},
      edit: false,
      searchOpened: false,
      drawerOpen: false,
      layoutMenuAnchor: null,
      selected: "main",
      fullScreenPortlet: {},
      searchAnchorEl: null,
      messageAnchorEl: null,
      searchString: this.props.match.params.str || "",
      fullscreenDialogOpen: true,
      messageOpened: false,
      handleMessageClickAway: false,
      routeSearchString: this.props.match.params.str || "",
      languageMenu: null,
      userTeams: [],
      selectedTeam: "",
      resolutions: [],
      whyPopperOpen: false,
      whyPopperAnchorEl: null,
      numSearchResults: 0,
      micOn: false, //this.props.currentUser.userSettings.micAlwaysEnabled,
      // micTempOn:false,
      searchTime: 0,
      secondaryInfo: this.props.applicationProperties[
        PropertyNames.SEARCH_SECONDARY_INFO
      ]
        ? JSON.parse(
            this.props.applicationProperties[
              PropertyNames.SEARCH_SECONDARY_INFO
            ]
          )
        : ["global_topic"],
      examplesOpen: false,
      examples: [],
      selectedExample: {},
    };
  }

  componentDidMount() {
    this.setState({
      messageAnchorEl: ReactDOM.findDOMNode(messageRef.current),
    });
    axios.get("/apidocs/").then((res) => {
      let examples = {};
      res.data.forEach((e) => {
        if (!examples[e.menutitle]) {
          examples[e.menutitle] = [];
        }
        examples[e.menutitle].push(e);
      });
      this.setState({ examples });
    });
  }

  openSearchFilter = () => {
    this.setState({ searchOpened: true }, () => {
      if (!this.props.location.pathname.includes("search")) {
        this.props.history.push("/search/");
      }
    });
  };

  handleInputRef = (node) => {
    this.setState({ searchAnchorEl: node });
  };

  handleMessageInputRef = (node) => {
    this.setState({ messageAnchorEl: node });
  };

  handleClickAway = () => {
    this.setState({ searchOpened: false });
  };

  handleMessageClickAway = () => {
    this.setState({ handleMessageClickAway: false });
  };
  getUserTeams = () => {
    taxServiceClient
      .get(`/user/${this.props.currentUser.userId}/team/`)
      .then((res) => {
        this.setState({ userTeams: res.data });
      });
  };
  teamChange = (evt) => {
    this.setState({ selectedTeam: evt.target.value });
  };
  closePopper = () => {
    this.setState({ whyPopperOpen: false });
  };
  showWhyLinkPopper = (e) => {
    this.setState({ whyPopperAnchorEl: e.target, whyPopperOpen: true });
  };
  activateSearch = () => {
    this.state.searchString
      ? this.props.history.push(`/search/${this.state.searchString}`)
      : this.props.history.push(`/search/`);
  };
  render() {
    const { classes, theme, t } = this.props;
    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
        }}
      >
        <AppBar
          position="sticky"
          className={classes.appBar}
          aria-label={t("app_header")}
        >
          <Toolbar>
            <Typography
              className={classes.title}
              variant="h6"
              component="h1"
              color="inherit"
              noWrap
              id="title"
              onClick={this.goHome}
            >
              Api Documentation
              {/* <Trans i18nKey="app_api_docs_home" /> */}
            </Typography>
            <div className={classes.grow} />
          </Toolbar>
          <div className={classes.tabsContainer} />
          {/* </> */}
        </AppBar>
        <Drawer
          open={true}
          onClose={this.toggleDrawer}
          classes={{
            paper: classes.drawerPaper,
          }}
          variant="persistent"
        >
          <div
            className={classes.drawerHeader}
            onClick={this.goHome}
            style={{
              backgroundImage: `url(${defaultLogo})`,
              backgroundSize: "85% 85%",
              backgroundPosition: "left",
              cursor: "pointer",
            }}
          />
          <List component="div">
            <ListItem
              button
              onClick={() => this.props.history.push("/apidocs")}
            >
              <ListItemIcon className={classes.listIcon}>
                <Icon path={mdiMagnify} size={1} />
              </ListItemIcon>
              <ListItemText primary="Overview" />
            </ListItem>
            <ListItem
              button
              onClick={() => this.props.history.push("/apidocs/usecases")}
            >
              <ListItemIcon className={classes.listIcon}>
                <Icon path={mdiAccountQuestion} size={1} />
              </ListItemIcon>
              <ListItemText primary="Use cases" />
            </ListItem>
            <ListItem button onClick={this.handleMenuClick}>
              <ListItemIcon className={classes.listIcon}>
                <CodeIcon />
              </ListItemIcon>
              <ListItemText primary="Examples" />
              {this.state.examplesOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={this.state.examplesOpen}>
              <List component="div" dense={true}>
                {Object.keys(this.state.examples).map((group) => {
                  return (
                    <>
                      <ListSubheader disableSticky>{group}</ListSubheader>
                      {this.state.examples[group].map((item) => {
                        return (
                          <ListItem
                            button
                            onClick={() => {
                              this.setState({ selectedExample: item }, () => {
                                this.props.history.push(
                                  `/apidocs/display/example/${item.id}`
                                );
                              });
                            }}
                          >
                            <ListItemText
                              className={classes.exampleListItem}
                              primary={item.title}
                            />
                          </ListItem>
                        );
                      })}
                    </>
                  );
                })}
                {/* {this.state.examples.map((item) => {
                  return (
                    <ListItem
                      button
                      onClick={() => {
                        this.setState({ selectedExample: item }, () => {
                          this.props.history.push(
                            `/apidocs/display/example/${item.id}`
                          );
                        });
                      }}
                    >
                      <ListItemText
                        className={classes.exampleListItem}
                        primary={item.title}
                      />
                    </ListItem>
                  );
                })} */}
              </List>
              {this.props.currentUser.isOperator === 1 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    onClick={() => {
                      this.props.history.push("/apidocs/create/example");
                    }}
                    variant="outlined"
                    startIcon={<AddIcon />}
                  >
                    New Example
                  </Button>
                </div>
              )}
            </Collapse>
            <ListItem
              button
              onClick={() => this.props.history.push("/apidocs/reference")}
            >
              <ListItemIcon className={classes.listIcon}>
                <Icon path={mdiApi} size={1} />
              </ListItemIcon>
              <ListItemText primary="API Reference" />
            </ListItem>
          </List>
        </Drawer>
        <Switch location={this.props.location} style={{ height: "100%" }}>
          <Route
            exact
            path="/apidocs"
            render={(props) => this.homePageLayout()}
          />
          <Route
            path="/apidocs/usecases"
            render={(props) => this.useCasesLayout()}
          />
          <Route
            path="/apidocs/display/example/:id"
            render={(props) => (
              <div className={classes.main}>
                <ApiExample {...props} />
              </div>
            )}
          />
          <Route
            path="/apidocs/create/example"
            render={(props) => (
              <div className={classes.main}>
                <ApiExample {...props} />
              </div>
            )}
          />
          <Route
            path="/apidocs/reference"
            render={(props) => this.referenceContentGetter(props)}
          />
        </Switch>

        {/* {(this.state.searchOpened && !this.props.history.location.pathname.includes("search")) && ( */}
        {/* {this.state.searchOpened && (
          <SearchBar
            asPopper
            anchorEl={this.state.searchAnchorEl}
            open={this.state.searchOpened}
            onClickAway={this.handleClickAway}
            onClose={this.closeSearchBar}
            searchString={this.state.searchString}
            activateSearch={this.activateSearch}
            searchInProgress={
              this.props.location.pathname.indexOf("search") > 0
            }
          />
        )} */}
      </div>
    );
  }
  handleMenuClick = () => {
    this.setState({ examplesOpen: !this.state.examplesOpen });
  };
  homePageLayout = (props) => {
    const { classes } = this.props;
    const title = "Universal Knowledge API Overview";
    const content = `
    The services provided by the API are REST endpoints returning data in JSON format and implements the OAuth2 standard for authentication. In order to use this guide you will need to be familiar with these technologies in order to proceed.
    All of the examples use HTML5, CSS3 and JavaScript ES6 with no additional javascript frameworks. They are designed as examples of how to utilize the API itself and as such minimal styling is applied which makes them unsuitable for live operation.
    They can be edited directly and opened in jsfiddle for further exploration.  A username and password for the application will be needed to run the examples, the authorization code has been included in all the examples for convenience to allow them to be run individually.
    `;
    return this.getPage(classes, title, content);
  };
  getPage = (classes, title, content) => {
    return (
      <div style={{ flex: 1, width: "100%", height: "100%" }}>
        {/* <AutoSizer>
          {({ height, width }) => ( */}
        <Card className={classes.main}>
          <CardHeader title={title} />
          <CardContent
            style={{ height: "100%", display: "flex", flexFlow: "column" }}
          >
            {content}
          </CardContent>
        </Card>
        {/* )}
        </AutoSizer> */}
      </div>
    );
  };
  useCasesLayout = (props) => {
    const { classes } = this.props;
    const title = "Common Use Cases for Universal Knowledge API";
    const content = (
      <ul>
        <li>
          To provide search capabilities for websites or 3rd party applications
        </li>
        <li>To provide a list of most commonly used solutions (FAQs)</li>
        <li>To provide an alternate simplified user interface</li>
        <li>To load knowledge from a source system</li>
      </ul>
    );
    return this.getPage(classes, title, content);
  };

  referenceContentGetter = (props) => {
    const { classes } = this.props;
    return (
      <div className={classes.main} style={{ flex: 1 }}>
        <iframe
          style={{ width: "100%", height: "100%" }}
          id={"swaggerframe"}
          frameBorder="0"
          src={`https://${this.props.apiLocation}/swagger-ui/index.html`}
          sandbox="allow-forms allow-pointer-lock allow-popups allow-modals allow-same-origin allow-scripts"
        />
      </div>
    );
  };

  getFullscreenDialog = (props, titleGetter, contentGetter) => {
    const { classes, t } = this.props;
    if (!this.state.fullscreenDialogOpen) {
      this.setState({ fullscreenDialogOpen: true });
    }
    return (
      <Dialog
        disableEnforceFocus
        fullScreen
        open={this.state.fullscreenDialogOpen}
        onClose={this.handleFullscreenDialogClosed}
        classes={{ paper: classes.dialogContainer }}
      >
        <AppBar
          className={classNames("pdf-hide", classes.modalAppBar)}
          // style={{ position: "fixed" }}
        >
          <Toolbar className={classes.modalToolbar}>
            <IconButton
              color="inherit"
              onClick={() => this.goHome()}
              aria-label={t("go_back")}
              autoFocus
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography
              variant="h6"
              component="h1"
              color="inherit"
              className={classes.flex}
            >
              {titleGetter(props)}
            </Typography>
            <IconButton
              color="inherit"
              className={classes.exitButton}
              aria-label={t("report_breadcrumb_home")}
              onClick={() => this.props.history.push("/apidocs")}
              id="go-home"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        {contentGetter(props)}
      </Dialog>
    );
  };

  searchKeypress = (e) => {
    if (e.key === "Enter") {
      this.closeSearchBar();
      this.props.history.push(`/search/${this.state.searchString}`);
    }
  };

  goHome = () => {
    this.props.history.push("/");
  };

  // RouterGlobalCustomFields = (props) => {
  //   if (!currentUserHasRole(Role.BE_EXPERT)) return <Redirect to="/" />;
  //   return <CustomFields global {...props} />;
  // };
  setPreviousResolutions = (prevResolutions) => {
    this.setState({
      resolutions: [...prevResolutions],
    });
  };
  setSearchStats = (results, time) => {
    this.setState({ numSearchResults: results, searchTime: time });
  };
  setSearchId = (searchId) => {
    this.setState({ searchId: searchId });
  };
  clearResolutions = () => {
    axios.delete(`/search/${this.state.searchId}/resolutions/`).then((res) => {
      this.setState({
        resolutions: this.state.resolutions.filter(
          (r) => typeof r === "object"
        ),
      });
    });
  };
  onResolution = (res) => {
    this.state.resolutions.indexOf(res) < 0 &&
      this.setState((prevState) => ({
        resolutions: Array.prototype.concat(prevState.resolutions, [res]),
      }));
  };
  onUnResolved = (res) => {
    this.setState((prevState) => ({
      resolutions: prevState.resolutions.filter((item) => item !== res),
    }));
  };

  toggleDrawer = () => {
    this.setState((prev) => ({ drawerOpen: !prev.drawerOpen }));
  };
  openProfilePage = () => {
    this.setState({ drawerOpen: false });
    this.props.history.push("/profile");
  };
  _openElementWrapper = (e) => {
    var portlet = e.detail.portlet;
    portlet.instance = null;
    portlet.cansort = false;
    this.setState({ fullScreenPortlet: portlet });
    this.setState({ drawerOpen: false });
    this.props.history.push("/fullscreen");
  };
}

const mapStateToProps = (state) => ({
  searchOpened: state.search.open,
  userLanguage: state.user.language,
  currentUser: state.user.currentUser,
  filters: state.search.filters,
  applicationProperties: state.setting.applicationProperties,
  apiLocation: state.setting.apiLocation,
});

const mapDispatchToProps = {
  setLayoutType,
  changeLanguage,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTheme(withStyles(styles)(withLastLocation(withTranslation()(ApiHome)))))
);
